import React from 'react';

const InputField = (props) => {
    const {
        inputName,
        inputTitle,
        inputValue,
        placeHolder,
        changeHandler,
        setHandler,
        inputStyle,
        inputType,
        inputReadOnly,
        inputCheck,
        classes,
    } = props;

    if (inputType === 'checkbox') {
        return (
            <input
                type={inputType}
                className={classes}
                id={inputName}
                name={inputName}
                checked={inputCheck}
                onChange={() => changeHandler(!inputCheck)}
            />
        );
    } else {
        return (
            <input
                type={inputType || 'text'}
                className={classes || 'form-control'}
                id={inputName}
                name={inputName}
                placeholder={placeHolder}
                onChange={(e) => changeHandler(e, setHandler)}
                value={inputValue}
                autoComplete="off"
                readOnly={inputReadOnly || false}
                title={inputTitle}
                style={inputStyle}
            />
        );
    }
};

export default InputField;
